const e = {
  COOKIE: "cookieAuth",
  BEARER: "bearerAuth",
  OAUTH2: "oauth2"
}, t = {
  [e.COOKIE]: {
    type: "apiKey",
    in: "cookie",
    name: "session_id",
    description: "Session cookie authentication"
  },
  [e.BEARER]: {
    type: "http",
    scheme: "bearer",
    bearerFormat: "JWT",
    description: "Bearer token authentication (use access_token directly)"
  },
  [e.OAUTH2]: {
    type: "oauth2",
    flows: {
      password: {
        tokenUrl: "/api/auth/token",
        scopes: {}
      }
    },
    description: "OAuth2 password flow authentication"
  }
}, o = [
  { [e.COOKIE]: [] },
  { [e.BEARER]: [] },
  { [e.OAUTH2]: [] }
];
export {
  e as SecuritySchemes,
  o as authSecurity,
  t as securitySchemes
};
//# sourceMappingURL=security.js.map
